import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class OrganizationService {
    /** Returns the raw user object from localStorage or null if not present/parsable. */
    getUser(): any | null {
        try {
            const raw = localStorage.getItem("user");
            if (!raw) return null;
            return JSON.parse(raw);
        } catch {
            return null;
        }
    }

    /** Returns the user's organization object or null */
    getOrganization(): any | null {
        const user = this.getUser();
        return user?.organization ?? null;
    }

    /** Returns the normalized organization name (lowercased, trimmed) or null */
    getOrganizationName(): string | null {
        const org = this.getOrganization();
        const name: string | null = org?.name ?? null;
        return name ? name.toString().trim().toLowerCase() : null;
    }

    /** Checks if current organization is one of provided names (case-insensitive). */
    isOneOf(allowedOrganizations: string[]): boolean {
        if (!allowedOrganizations || allowedOrganizations.length === 0) return false;
        const current = this.getOrganizationName();
        if (!current) return false;
        const normalizedAllowed = allowedOrganizations.map((o) => o.trim().toLowerCase());
        return normalizedAllowed.includes(current);
    }

    /** Convenience for Appcelerate orgs */
    isAppcelerate(): boolean {
        return this.isOneOf(["Appcelerate", "Appcelerate-dev", "APPCELERATE LATAM"]);
    }
}
